import { FoodProductProperties, TaxonomyItemPatientWeightProperties } from "modules/TaxonomyModule/consts";

export const foodProductPropsKeys: string[] = Object.values({
  ...FoodProductProperties,
  ...TaxonomyItemPatientWeightProperties
});

export const foodProductRelationsKeys: string[] = [];
